"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var EventHandlerService_1 = require("../../../../Services/EventHandlerService");
var Components_1 = require("../../../../Components");
var Util_1 = require("../../../../Services/Util");
var react_bootstrap_table_next_1 = require("react-bootstrap-table-next");
var react_bootstrap_table2_paginator_1 = require("react-bootstrap-table2-paginator");
var react_bootstrap_table2_toolkit_1 = require("react-bootstrap-table2-toolkit");
var Types_1 = require("./Types");
var Components_2 = require("./Components");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var AuthenticationService_1 = require("../../../../Services/AuthenticationService");
var Users = /** @class */ (function (_super) {
    __extends(Users, _super);
    function Users(props) {
        var _this = _super.call(this, props) || this;
        _this.onUpdate = function () {
            _this.getUserData();
            _this.getUsers(100, 0, { field: Types_1.UsersTableField["Email"], descending: false }, { email: "", displayName: "", userRole: "Administrator" }, { email: "", displayName: "" })
                .then(function (response) { _this.setState({ admins: response.item1 }); });
        };
        _this.getUserData = function (fetchAmount, page, order, filter, search) {
            if (fetchAmount === void 0) { fetchAmount = _this.tableRef.current.paginationContext.currSizePerPage; }
            if (page === void 0) { page = _this.tableRef.current.paginationContext.currPage; }
            if (order === void 0) { order = { field: Types_1.UsersTableField["Email"], descending: false }; }
            if (filter === void 0) { filter = { email: "", displayName: "", userRole: "", defaultLocation: "" }; }
            if (search === void 0) { search = { email: "", displayName: "" }; }
            var errMsg = "";
            _this.getUsers(fetchAmount, page, order, filter, search)
                .then(function (response) {
                var totalPages = Math.ceil(response.item2 / fetchAmount);
                var users = [];
                response.item1.forEach(function (data) {
                    var localisedRoles = "";
                    data.userRole.split(', ').forEach(function (value, index, array) {
                        localisedRoles += _this.props.applicationData.resources[value];
                        if (index + 1 < array.length) {
                            localisedRoles += ', ';
                        }
                    });
                    users.push(__assign(__assign({}, data), { userRole: localisedRoles, Actions: React.createElement("div", { style: {
                                display: 'flex', justifyContent: 'space-evenly'
                            } },
                            React.createElement(reactstrap_1.Button, { color: "primary", onClick: function () {
                                    EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.ResetPasswordEvent(_this.onUpdate, data, _this.props.applicationData.resources));
                                } },
                                React.createElement("span", { className: "fa-layers fa-fw" },
                                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faUndo }),
                                    " ")),
                            React.createElement(reactstrap_1.Button, { color: "primary", onClick: function () {
                                    EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.EditUserEvent(_this.onUpdate, data, _this.props.applicationData.resources, _this.props.applicationData.locations));
                                } },
                                React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faPencilAlt })),
                            (_this.currentUser.id !== data.id && !data.userRole.match(/SuperUser/g)) &&
                                React.createElement(reactstrap_1.Button, { color: "danger", onClick: function () {
                                        //console.log("delete clicked");
                                        EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.DeleteUserEvent(_this.onUpdate, data, _this.props.applicationData.resources));
                                    } },
                                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTrash }))) }));
                });
                _this.setState({
                    users: users,
                    totalPages: response.item2
                });
            }).catch(function (err) {
                errMsg = err.value || err;
            });
            if (errMsg) {
                console.error(errMsg);
            }
            _this.setState({
                errorMessage: errMsg
            });
        };
        _this.getOrder = function (newState) {
            var order = {};
            order.descending = newState.sortOrder === "desc";
            if (newState.sortField === "displayName") {
                order.field = Types_1.UsersTableField.DisplayName;
            }
            else if (newState.sortField === "email") {
                order.field = Types_1.UsersTableField.Email;
            }
            else if (newState.sortField === "userRole") {
                order.field = Types_1.UsersTableField.UserRole;
            }
            else if (newState.sortField === "defaultLocation") {
                order.field = Types_1.UsersTableField.DefaultLocation;
            }
            return order;
        };
        _this.onTableChange = function (type, newState) {
            _this.setState({
                users: []
            });
            switch (type) {
                case "filter":
                    break;
                case "pagination":
                    _this.getUserData(newState.sizePerPage, newState.page, _this.getOrder(newState), undefined, undefined);
                    break;
                case "sort":
                    _this.getUserData(newState.sizePerPage, newState.page, _this.getOrder(newState), undefined, undefined);
                    break;
                case "search":
                    _this.getUserData(newState.sizePerPage, newState.page, _this.getOrder(newState), undefined, { email: newState.searchText, displayName: newState.searchText });
                    break;
                case "cellEdit":
                    break;
                default:
                    console.warn("Unknown table change event: " + type);
                    //console.log(newState);
                    break;
            }
        };
        //console.log("constructor");
        _this.tableRef = React.createRef();
        _this.state = {
            users: [],
            totalPages: 1,
            errorMessage: "",
            isLoading: false,
            admins: []
        };
        _this.currentUser = AuthenticationService_1.Auth.getUser();
        return _this;
    }
    Users.prototype.componentDidMount = function () {
        this.onUpdate();
    };
    Users.prototype.getUsers = function (fetchAmount, page, order, filter, search) {
        var _this = this;
        this.setState({ isLoading: true });
        return Util_1.getJson("/users/GetUsers?pageSize=" + fetchAmount + "&pageIndex=" + page + "&order=" + Types_1.UsersTableField[order.field] + "&descending=" + order.descending + "&filter=" + encodeURIComponent(JSON.stringify(filter)) + "&search=" + encodeURIComponent(JSON.stringify(search)), {
            method: "get",
            headers: {
                "Accept": "application/json, application/xml, text/plain, text/html, *.*",
                "Content-Type": "application/json;"
            }
        }).then(function (response) {
            _this.setState({ isLoading: false });
            return response;
        });
    };
    Users.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "my-1" },
            React.createElement(react_bootstrap_table2_toolkit_1.default, { keyField: "id", data: this.state.users, columns: Types_1.UsersTableColumns(this.props.applicationData.resources), search: true }, function (props) { return (React.createElement("div", null,
                React.createElement("div", { className: "my-2" },
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, { sm: "auto" },
                            React.createElement(reactstrap_1.Row, { className: "mx-auto" },
                                React.createElement(reactstrap_1.Col, { sm: "auto" },
                                    React.createElement("h2", null, _this.props.applicationData.resources.Users)),
                                React.createElement(reactstrap_1.Col, { sm: "auto", className: "fv-c" },
                                    React.createElement(Components_2.SearchBar, __assign({}, props.searchProps, { resources: _this.props.applicationData.resources }))),
                                React.createElement(reactstrap_1.Col, null))),
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { sm: "auto", className: "fv-c" },
                            _this.props.applicationData.userInfo.UserRole.match(/SuperUser/g) && React.createElement(reactstrap_1.Button, { className: "users-add-btn ml-3", color: "primary", onClick: function () {
                                    EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.TransferSuperUserEvent(_this.onUpdate, _this.state.admins, _this.props.applicationData.resources));
                                } },
                                " ",
                                _this.props.applicationData.resources.TransferSuperUser,
                                " "),
                            React.createElement(reactstrap_1.Button, { className: "users-add-btn ml-3", color: "primary", onClick: function () {
                                    EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(Types_1.AddUserEvent(_this.onUpdate, _this.props.applicationData.locations, _this.props.applicationData.resources));
                                } },
                                " ",
                                _this.props.applicationData.resources.Registration_AddUserHeading,
                                " ")))),
                React.createElement(react_bootstrap_table_next_1.default, __assign({}, props.baseProps, { bootstrap4: true, condensed: true, hover: _this.state.users.length > 0, noDataIndication: function () { return _this.state.isLoading ? React.createElement(Components_1.CustomSpinner, null) : React.createElement("div", null, _this.props.applicationData.resources.NoData); }, remote: {
                        filter: false,
                        pagination: true,
                        sort: true,
                        cellEdit: false
                    }, ref: _this.tableRef, onTableChange: _this.onTableChange, bordered: false, keyField: "email", defaultSorted: Types_1.UsersTableDefaultSort, pagination: react_bootstrap_table2_paginator_1.default({ totalSize: _this.state.totalPages }) })))); })));
    };
    return Users;
}(React.Component));
exports.Users = Users;
//# sourceMappingURL=Users.js.map